
import React from 'react';
import config from 'react-global-configuration';
import {
  CoreLink,
  Menu,
} from '@uncinc/react-drupal-core';

import { DOMAIN_VNL } from '../../../config/constants';

const FooterSecondaryMenu = () => {
  const currentDomain = config.get('CURRENT_DOMAIN');

  const menu = currentDomain === DOMAIN_VNL ? 'secondary-footer' : 'secondary-footer-kvnl';

  return (
    <Menu id={menu}>
      {(items) => {
        return (
          <div className="Footer__secondary">
            {items.map((item, index) => {
              const linkHref = item.getIn(['link', 'url']);
              const linkTitle = item.getIn(['link', 'title'], '');

              return (
                <CoreLink to={linkHref} key={linkTitle}>{linkTitle}</CoreLink>
              );
            })}
          </div>
        );
      }}
    </Menu>
  );
};

export default FooterSecondaryMenu;
